const download = (response, fileName) => {
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  if ('msSaveOrOpenBlob' in window.navigator) {
    // IE,Edge浏览器
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
  }

  // let a = document.createElement('a');
  // a.style.display = 'none';
  // document.body.appendChild(a);
  // const url = window.URL || window.webkitURL || window.moxURL;
  // let link = url.createObjectURL(blob);
  // a.href = link;
  // a.download = fileName;
  // a.click();
  // document.body.removeChild(a);
  // window.URL.revokeObjectURL(link);
};

export default download;
